"use client";
import AdminUserDetails from "../../../../components/AdminUserDetails/AdminUserDetails";
import isAuth from "../../../../components/IsAuth/IsAuth";


const Add = () => {
    return <AdminUserDetails></AdminUserDetails>
}

export default isAuth(Add);